import { FC } from "react";
import "../CSS/CalendarScreenHeader.css";
import appIcon from "../../../assets/images/header-app-icon.svg";
import appTextIcon from "../../../assets/images/header-text-icon.svg";
import MonthYearPicker from "../../../components/elements/MonthYearPicker";
import EventsMonthYearPicker from "components/elements/EventsMonthYearPicker";

interface CalendarScreenHeaderProps {
  onlyMonthYearSelection: boolean;
  selectedDate: Date;
  setSelectedDate: (date: string) => void;
}

const CalendarScreenHeader: FC<CalendarScreenHeaderProps> = ({
  onlyMonthYearSelection,
  selectedDate,
  setSelectedDate,
}) => {
  return (
    <header className="calendar-screen-header-bar">
      <div className="calendar-screen-header-left-container">
        <img src={appIcon} alt="logo" />
      </div>
      <div className="calendar-screen-header-divider"></div>
      <div className="calendar-screen-header-right-container">
        <div>
          {onlyMonthYearSelection ? (
            <EventsMonthYearPicker
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              setCurrentDate={onlyMonthYearSelection}
            />
          ) : (
            <MonthYearPicker
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              setCurrentDate={onlyMonthYearSelection}
            />
          )}
        </div>
        <img src={appTextIcon} alt="logo" />
      </div>
    </header>
  );
};

export default CalendarScreenHeader;
